<template>
  <div id="promotion_usages">
    <Panel :title="$t('promotion_usage.statistics')">
      <div class="subtitle">{{$t('description')}}</div>
      <div id="description">
        <div>{{$t('promotion_usage.promotion_name')}}: {{$to(promotion.name) || Object.values(promotion.name)[0] }}</div>
      </div>

      <div class="subtitle">{{$t('promotion_usage.statistics')}}</div>
      <div id="stats">
        <div><b>{{$t('promotion_usage.totalUsage')}}</b>: {{stats.totalUsage}}</div>
        <div><b>{{$t('promotion_usage.totalUniqueUser')}}</b>: {{stats.totalUniqueUser}}</div>
        <div><b>{{$t('promotion_usage.totalByCurrency')}}</b>: <template v-for="(total, currency) of stats.totalByCurrency">{{total}} {{currency.toUpperCase()}}</template></div>
      </div>
      <div class="subtitle">{{$t('filters')}}</div>
      <div id="filters">
        <div class="columns">
          <div class="column">
            <div class="group">
              <label>{{$t('start')}}</label>
              <datetime type="datetime" v-model="filters.start" :use12-hour="hourFormat == '12'"/>
            </div>
          </div>
          <div class="column">
            <div class="group">
              <label>{{$t('end')}}</label>
              <datetime type="datetime" v-model="filters.end" :use12-hour="hourFormat == '12'"/>
            </div>
          </div>
        </div>
      </div>
      <button class="btn btn-primary" @click="applyFilters(false)" v-if="!(filters.start && filters.end)">{{$t('promotion_usage.generate_report')}}</button>
    </Panel>
    <Datatable
      entity="promotion_usage_by_promo"
      class="datatable"
      ref="datatable"
      v-if="filters.start && filters.end"
      :parameters="datatableParameters"
      :onRowClick="onRowClick"
      :addShowAll="true"
      :rowActions="[
        {text: 'datatable.view_sale', method: onRowClick}
      ]"
    />
  </div>
</template>

<script>
  import Datatable from "@/components/Datatable.vue";
  import { mapActions } from "vuex";

  export default {
    name: "PromotionUsage",

    components: { Datatable },

    data() {
      return {
        filters: {
          start: null,
          end: null
        },
        inventory: null,
        promotion: {
          name: {}
        },
        stats: {
          totalByCurrency: {},
          totalUsage: null,
          totalUniqueUser: null
        }
      }
    },

    watch: {
      "filters.start"() {
        this.persistFilters();
      },
      "filters.end"() {
        this.persistFilters();
      }
    },

    async mounted() {
      showSpinner();
      this.inventory = await this.$store.getters.getContextInventory;
      this.loadURLQueryParams();
      hideSpinner();
      this.applyFilters(true);
    },

    computed: {
      datatableParameters() {
        return {
          promotion: this.promotionId,
          start: this.filters.start,
          end: this.filters.end
        }
      },
      hourFormat() {
        if (this.$store.state.contextCompany) {
          return this.$store.state.contextCompany.hourFormat;
        }
        return "24";
      },
      promotionId() {
        return this.$route.query.id
      },
      branchId() {
        return this.$route.query.branch
      },
      companyId() {
        return this.$route.query.company
      }
    },

    methods: {
      ...mapActions(["statsOfPromotion"]),

      loadURLQueryParams() {
        let query = this.$router.currentRoute.query;
        if (query.start) {
          this.filters.start = decodeURIComponent(query.start);
        }
        if (query.end) {
          this.filters.end = decodeURIComponent(query.end);
        }
      },

      persistFilters() {
        let newQuery = JSON.parse(JSON.stringify(this.$router.currentRoute.query));
        if (this.filters.start) {
          newQuery.start = encodeURIComponent(this.filters.start);
        }
        if (this.filters.end) {
          newQuery.end = encodeURIComponent(this.filters.end);
        }
        this.$router.replace({ query: newQuery }).catch(() => {});
      },

      async applyFilters(init) {
        if (!(this.filters.start && this.filters.end) && !init) {
          toast(this.$t('promotion_usage.invalid'), "error");
          return;
        }
        /* doesn't need to show spinner, because already showing from the datatable update ...*/
        let response = await this.statsOfPromotion({
          inventory: this.inventory.id,
          id: this.promotionId,
          filters: {
            start: this.fixDateTime(this.filters.start),
            end: this.fixDateTime(this.filters.end)
          }
        });
        if (response) {
          this.promotion = response.promotion;
          Object.assign(this.stats, response.stats);
        }
      },

      onRowClick(row) {
        this.$router.push({ path: '/sale', query : { id : row.saleNumber, branch: this.branchId, company: this.companyId }});
      },
      fixDateTime(datetime) {
        if (!datetime) {
          return null
        }
        return datetime.replace('T', ' ').substr(0, 19)
      },
    }
  }
</script>

<style lang="scss" scoped>
  .panel .subtitle {
    margin-bottom: 10px;
    &:not(:first-child) {
      padding-top: 30px;
    }
  }
  #stats {
    display: flex;
    div {
      flex-grow: 1;
    }
  }
</style>

<style lang="scss">
  #promotion_usages .vdatetime-input {
    width: 100%;
  }
</style>
